import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { SessionIgnoreReportTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { SessionIgnoreReportSchemaObject } from '../SessionIgnoreReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = "SESSIONIGNOREREPORT";

export function SessionIgnoreReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [division, setDivision] = useState([]);
    const [field, setField] = useState([]);

    const [isTableHide, setIsTableHide] = useState(true);

    const [sessionIgnoreDetails, setSessionIgnoreDetails] = useState({
        groupID: "0",
        estateID: "0",
        collectionPointID: "0",
        collectionPointName: "",
        fromDate: '',
        toDate: '',
        status: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        collectionPoint: "",
        fromDate: '',
        toDate: '',
        status: "0"
    });

    const csvHeaders = [
        { label: "Division", value: "collectionPointName" },
        { label: "Date", value: "date" },
        { label: "Emp Name", value: "firstName" },
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Reason", value: "requestReason" },
        { label: "Reject Reason", value: "rejectReason" },
        { label: "Status", value: "statusName" },
    ];

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });
    const [reportData, setReportData] = useState([]);

    const schema = Joi.object(SessionIgnoreReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["collectionPointName", "date", "firstName", "registrationNumber",
        "requestReason", "rejectReason", "statusName"];



    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
    }, [sessionIgnoreDetails.groupID])

    useEffect(() => {
        trackPromise(getDivisionForDropdown())
    }, [sessionIgnoreDetails.estateID]);

    useEffect(() => {
        trackPromise(getFieldForDropdown())
    }, [sessionIgnoreDetails.divisionID]);

    function handleGroupChange(target) {
        validateInputs(target);

        setSessionIgnoreDetails({
            ...sessionIgnoreDetails,
            groupID: target.value,
            estateID: "0",
            date: "",
            collectionPointID: "0",
            fieldID: "0",
            regNumber: ""
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setSessionIgnoreDetails({
            ...sessionIgnoreDetails,
            estateID: target.value,
            date: "",
            collectionPointID: "0",
            fieldID: "0",
            regNumber: ""
        });
        clearTable();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setSessionIgnoreDetails({
            ...sessionIgnoreDetails,
            date: target.value
        });
        clearTable();
    }

    function handleChangeCommon(target) {
        validateInputs(target);

        setSessionIgnoreDetails({
            ...sessionIgnoreDetails,
            [target.name]: target.value
        });
        clearTable();
    }

    function handleChangeDivision(target) {
        validateInputs(target);

        setSessionIgnoreDetails({
            ...sessionIgnoreDetails,
            collectionPointID: target.value,
            fieldID: "0",
            regNumber: ""
        });
        clearTable();
    }
    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, SessionIgnoreReportSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setSessionIgnoreDetails({
            ...sessionIgnoreDetails,
            [e.target.name]: value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, SessionIgnoreReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSESSIONIGNOREREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setSessionIgnoreDetails({
            ...sessionIgnoreDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(sessionIgnoreDetails.groupID);
        setEstates(data);
    }

    async function getDivisionForDropdown() {
        const data = await services.GetDivisionByEstateID(sessionIgnoreDetails.estateID);
        setDivision(data);
    }

    async function getFieldForDropdown() {
        const data = await services.GetFieldsByCollectionPoint(sessionIgnoreDetails.divisionID);
        setField(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();

        destroyDataTable();
        setIsTableHide(true);

        const errorMessages = validate(schema, sessionIgnoreDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getReportData(sessionIgnoreDetails);

        var mergedArray = [];

        if (result !== null) {
            result.forEach(x => {
                x.date = x.date.split('T')[0]
                if(x.statusID == 2){
                    x.statusName = "Approve"
                }
                else {
                    x.statusName = "Reject"
                }
                if (mergedArray.length === 0) {
                    mergedArray.push(x);
                } else {
                    var isAvialable = mergedArray.find(y => y.fieldID === x.fieldID && y.registrationNumber === x.registrationNumber);

                    if (isAvialable) {
                        isAvialable.numberOfUnits = parseInt(isAvialable.numberOfUnits) + parseInt(x.numberOfUnits);
                        isAvialable.totalAmount = parseFloat(isAvialable.totalAmount) + parseFloat(x.totalAmount);
                        isAvialable.grossAmount = parseFloat(isAvialable.grossAmount) + parseFloat(x.grossAmount);
                        isAvialable.netAmount = parseFloat(isAvialable.netAmount) + parseFloat(x.netAmount);
                        isAvialable.totalDeduction = parseFloat(isAvialable.totalDeduction) + parseFloat(x.totalDeduction);
                    } else {
                        mergedArray.push(x);
                    }
                }

            });
        }


        setReportData(result);

        if (mergedArray.length != 0) {
            setIsTableHide(false);
            createDataTable();
            addSelectedSearchValues();
            setCsvData(result);
        }
    }

    function addSelectedSearchValues() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[sessionIgnoreDetails.groupID],
            estate: estates[sessionIgnoreDetails.estateID],
            collectionPoint: division[sessionIgnoreDetails.collectionPointID],
            toDate: sessionIgnoreDetails.toDate,
            fromDate: sessionIgnoreDetails.fromDate,
            status: sessionIgnoreDetails.status,
        })
    }

    function destroyDataTable() {
        $("#blockWeighment").DataTable().destroy();
    }

    function createDataTable() {
        $('#blockWeighment').DataTable();
    }

    function createFile() {
        var settings = {
            sheetName: 'Session Ignore Report',
            fileName: 'SessionIgnoreReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            collectionPointName: "Group :" + groups[sessionIgnoreDetails.groupID],
            date: "Estate : " + estates[sessionIgnoreDetails.estateID],
            firstName: "From Date : " + sessionIgnoreDetails.fromDate,
            registrationNumber: "To Date : " + sessionIgnoreDetails.toDate
        }
        var newRow2 = {
            collectionPointName: "Division : " + [selectedSearchValues.collectionPoint === undefined ? "All Divisions" : selectedSearchValues.collectionPoint],
            date: "Status : " + [sessionIgnoreDetails.status === "0" ? "All Status" : sessionIgnoreDetails.status === "2" ? "Approved" : "Rejected"],
        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setSessionIgnoreDetails({
            ...sessionIgnoreDetails,
            date: "",
            division: "0",
            field: "0",
            regNumber: ""
        });
        setIsTableHide(true);
        setErrors("");
    }

    function clearTable() {
        setIsTableHide(true);
        setReportData([]);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Session Ignore Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                            >
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={sessionIgnoreDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={sessionIgnoreDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointID">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={sessionIgnoreDetails.collectionPointID}
                                            onChange={(e) => handleChangeDivision(e.target)}
                                        >
                                            <MenuItem value="0">--All Division--</MenuItem>
                                            {generateDropDownMenu(division)}
                                        </Select>
                                        {errors["collectionPointID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField
                                            id="fromDate"
                                            label="From Date *"
                                            name="fromDate"
                                            type="date"
                                            fullWidth
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className="col-md pb-1">
                                        <TextField
                                            id="toDate"
                                            label="To Date *"
                                            name="toDate"
                                            type="date"
                                            fullWidth
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md">
                                        <TextField select fullWidth
                                            label="Status "
                                            id="status"
                                            name="status"
                                            value={sessionIgnoreDetails.status}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Status--</option>
                                            <option value="2">Approved</option>
                                            <option value="3">Rejected</option>
                                        </TextField>
                                    </div>

                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, sessionIgnoreDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12 pt-2 pb-3">
                                            <div className="card p-2">
                                                <div className="table-responsive row-top-gap">
                                                    <table id="blockWeighment" className="display dataTable no-footer">
                                                        <thead>
                                                            <tr>
                                                                <th>Division</th>
                                                                <th>Date</th>
                                                                <th>Emp Name</th>
                                                                <th>Reg No</th>
                                                                <th>Reason</th>
                                                                <th>Reject Reason</th>
                                                                <th>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <SessionIgnoreReportTableContent
                                                                data={reportData}
                                                                contentRowNames={contentRowNames}
                                                                hasEdit={false}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Session Ignore Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} reportData={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
